export default __webpack_public_path__ + "static/media/preview.6275b4e1.png";